import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/modules/shared/ui/components/alert-dialog"
import { useBulkDeleteDocuments } from "../../hooks/useDocuments"

interface BulkDeleteDocumentsDialogProps {
  documentIds: string[]
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted?: () => void
}

export function BulkDeleteDocumentsDialog({
  documentIds,
  open,
  onOpenChange,
  onDeleted,
}: BulkDeleteDocumentsDialogProps) {
  const bulkDelete = useBulkDeleteDocuments()

  const handleConfirm = () => {
    bulkDelete.mutate(documentIds, {
      onSuccess: () => {
        onOpenChange(false)
        onDeleted?.()
      },
    })
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete {documentIds.length} document{documentIds.length !== 1 ? "s" : ""}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            The selected documents will be deleted. You can restore them individually
            afterwards.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={bulkDelete.isPending}
            onClick={handleConfirm}
          >
            {bulkDelete.isPending ? "Deleting…" : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
